import {MAP_SCALE_DATA} from "../modules/WMS/Enums";
import React from "react";
import {CarOutlined} from "@ant-design/icons";

export const BMapUtils = {
    //算出上下左右四个界限，交给后台查询坐标
    calculateRange: (showRangeValue, centerPoint, bmap) => {
        let zoom = bmap.getZoom();
        //获取到地图上的像素坐标
        let pointPixel = bmap.pointToPixel(centerPoint);
        //根据Zoom比例和搜索范围，算出公里数对应的像素值
        let metre = showRangeValue * 1000;//x公里= x*1000 米
        let scaleData = MAP_SCALE_DATA[zoom];//获取缩放比例值
        let pixelLength = (scaleData.Pixels / scaleData.length) * metre;//（N像素/每米）* M米
        //利用像素点坐标+像素距离差，距离计算上下左右的坐标范围。
        let left = pointPixel.x - pixelLength;
        let right = pointPixel.x + pixelLength;
        let top = pointPixel.y - pixelLength;
        let bottom = pointPixel.y + pixelLength;
        //没有单个X/Y像素坐标值转经纬度点的方法，因此定义像素点，然后转成经纬度点。
        const leftTopPoint = bmap.pixelToPoint(new window.BMap.Pixel(left, top));
        const rightBottomPoint = bmap.pixelToPoint(new window.BMap.Pixel(right, bottom));

        let range = {};
        range["zonePointWest"] = leftTopPoint.lng;//西
        range["zonePointEast"] = rightBottomPoint.lng;//东
        range["zonePointSouth"] = rightBottomPoint.lat;//南
        range["zonePointNorth"] = leftTopPoint.lat;//北
        return range;
    },
    //计算矩形框的四个点，交给前台描绘
    calculateRectangle: (showRangeValue, centerPoint, bmap) => {
        let zoom = bmap.getZoom();
        //获取到地图上的像素坐标
        let pointPixel = bmap.pointToPixel(centerPoint);
        //根据Zoom比例和搜索范围，算出公里数对应的像素值
        let metre = showRangeValue * 1000;
        let scaleData = MAP_SCALE_DATA[zoom];
        let pixelLength = (scaleData.Pixels / scaleData.length) * metre;
        let left = pointPixel.x - pixelLength;
        let right = pointPixel.x + pixelLength;
        let top = pointPixel.y - pixelLength;
        let bottom = pointPixel.y + pixelLength;
        const leftTopPoint = bmap.pixelToPoint(new window.BMap.Pixel(left, top));
        const rightTopPoint = bmap.pixelToPoint(new window.BMap.Pixel(right, top));
        const rightBottomPoint = bmap.pixelToPoint(new window.BMap.Pixel(right, bottom));
        const leftBottomPoint = bmap.pixelToPoint(new window.BMap.Pixel(left, bottom));

        return [leftTopPoint, rightTopPoint, rightBottomPoint, leftBottomPoint];
    },
    //计算两点之间的行驶距离 flag: BMap == BL, BMapGL == GL
    calculateDistance: (startPoint, endPoint, map, flag, index) => {
        let searchComplete = function (results) {
            if (transit.getStatus() !== window.BMAP_STATUS_SUCCESS) {
                return;
            }
            let plan = results.getPlan(0);
            let div = document.getElementById("distance" + index);
            div.innerHTML = plan.getDuration(true) + "·相距" + plan.getDistance(true) + "  >";
            //console.log(div)
        }
        let transit;
        if (flag === "BL") {
            transit = new window.BMap.DrivingRoute(map, {
                renderOptions: {map: map},
                onSearchComplete: searchComplete
            });
        } else {
            transit = new window.BMapGL.DrivingRoute(map, {
                renderOptions: {map: map},
                onSearchComplete: searchComplete
            });
        }
        transit.search(startPoint, endPoint);

    },
    degrees_to_radians(degrees) {
        var pi = Math.PI;
        return degrees * (pi / 180);
    },
    calculateDriverDistance: (startPoint, endPoint, flag, refreshFunction) => {
        // x
        let transit;
        if (flag === "BL") {
            transit = new window.BMap.DrivingRoute(startPoint, {
                onSearchComplete: refreshFunction.call(this)
            });
        } else {
            transit = new window.BMapGL.DrivingRoute(startPoint, refreshFunction);
        }
        transit.search(startPoint, endPoint);
        let result = transit.getResults();
        console.log(result);
        let plan = result.getPlan(0);
        return plan.getDistance(true);
    },
    calculateRangeWithOutBMap(showRangeValue, centerPoint) {
        const R = 6371 * 1000;
        let metre = showRangeValue * 1000;
        let zonePointWest = centerPoint.lng - 180 * metre / (R * Math.PI * Math.cos(this.degrees_to_radians(centerPoint.lat)));
        let zonePointEast = 180 * metre / (R * Math.PI * Math.cos(this.degrees_to_radians(centerPoint.lat))) + centerPoint.lng;
        let zonePointSouth = centerPoint.lat - 180 * metre / (R * Math.PI);
        let zonePointNorth = centerPoint.lat + 180 * metre / (R * Math.PI);
        let range = {};
        range["zonePointWest"] = zonePointWest;//西
        range["zonePointEast"] = zonePointEast;//东
        range["zonePointSouth"] = zonePointSouth;//南
        range["zonePointNorth"] = zonePointNorth;//北
        return range;
    },


    calculateRectangleWithOutBMap(showRangeValue, centerPoint) {
        const R = 6371 * 1000;
        let metre = showRangeValue * 1000;
        let zonePointWest = centerPoint.lng - 180 * metre / (R * Math.PI * Math.cos(this.degrees_to_radians(centerPoint.lat)));
        let zonePointEast = 180 * metre / (R * Math.PI * Math.cos(this.degrees_to_radians(centerPoint.lat))) + centerPoint.lng;
        let zonePointSouth = centerPoint.lat - 180 * metre / (R * Math.PI);
        let zonePointNorth = centerPoint.lat + 180 * metre / (R * Math.PI);
        let range = {};
        range["zonePointWest"] = zonePointWest;//西
        range["zonePointEast"] = zonePointEast;//东
        range["zonePointSouth"] = zonePointSouth;//南
        range["zonePointNorth"] = zonePointNorth;//北
        const leftTopPoint = new window.BMap.Point(zonePointWest, zonePointNorth);
        const rightTopPoint = new window.BMap.Point(zonePointEast, zonePointNorth);
        const rightBottomPoint = new window.BMap.Point(zonePointEast, zonePointSouth);
        const leftBottomPoint = new window.BMap.Point(zonePointWest, zonePointSouth);
        return [leftTopPoint, rightTopPoint, rightBottomPoint, leftBottomPoint];

    }
}